var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartHeartFilled = function SvgHeartHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3C13.605 3 12 5.09 12 5.09S10.395 3 7.5 3A5.5 5.5 0 0 0 2 8.5c0 4.171 4.912 8.213 6.281 9.49C9.858 19.46 12 21.35 12 21.35s2.142-1.89 3.719-3.36C17.088 16.713 22 12.671 22 8.5A5.5 5.5 0 0 0 16.5 3"
  })));
};
export default SvgHeartHeartFilled;